import { STOPS } from "@/lib/tours";
import { IMAGES } from "@/lib/images";
import Reveal from "@/components/landing/Reveal";

const Stop = ({ name, index, isLast }) => {
  const stop = STOPS[name];
  return (
    <li data-testid={`tour-stop-${index + 1}`} className="relative grid gap-5 pb-12 pl-14 sm:grid-cols-[1fr_220px] sm:gap-8 sm:pl-20">
      {!isLast && (
        <span className="absolute left-[19px] top-12 h-[calc(100%-3rem)] w-px bg-gradient-to-b from-amber-400/50 to-white/5 sm:left-[23px]" />
      )}
      <span className="absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-full border border-amber-400/40 bg-[#0D1117] font-mono text-xs font-bold text-amber-400 sm:h-12 sm:w-12 sm:text-sm">
        {String(index + 1).padStart(2, "0")}
      </span>
      <div>
        <h3 className="font-display text-xl font-bold text-stone-50 sm:text-2xl">{name}</h3>
        <p className="mt-3 max-w-xl text-sm leading-relaxed text-stone-400 sm:text-base">
          {stop.description}
        </p>
      </div>
      <div className="overflow-hidden rounded-xl border border-white/10">
        <img
          src={IMAGES[stop.image]}
          alt={name}
          loading="lazy"
          className="aspect-[4/3] h-full w-full object-cover transition-transform duration-700 ease-out hover:scale-105"
        />
      </div>
    </li>
  );
};

export default function TourItinerary({ tour }) {
  return (
    <section className="border-y border-white/10 bg-[#161B22]/40">
      <div className="mx-auto max-w-7xl px-5 py-20 sm:px-8 sm:py-28">
        <Reveal>
          <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-amber-400">
            Roteiro
          </p>
          <h2 className="mt-4 font-display text-3xl font-extrabold leading-tight tracking-tight text-stone-50 sm:text-4xl">
            Parada{" "}
            <em className="font-accent font-medium italic text-amber-400">a parada.</em>
          </h2>
          <p className="mt-5 max-w-xl text-sm leading-relaxed text-stone-400 sm:text-base">
            A ordem pode variar conforme o clima, o trânsito e o movimento nas atrações —
            sempre pensando no melhor horário e na melhor luz para cada lugar.
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <ol data-testid="tour-itinerary" className="mt-14">
            {tour.stops.map((name, i) => (
              <Stop key={name} name={name} index={i} isLast={i === tour.stops.length - 1} />
            ))}
          </ol>
        </Reveal>
      </div>
    </section>
  );
}
